import { createGlobalStyle } from "styled-components";
// import { LOGO } from "@assets";

const GlobalStyles = createGlobalStyle`
* {
  margin: 0;
  font-family: 'Poppins', 'Myanmar Phetsot';
}

body {
  display: flex;
  align-items: center;
  justify-content: center;
}

#root {
  width: 100vw;
  max-width: 480px;
  min-height: 100vh;
  background: ${(props) => props.theme.background};   
}

.ant-spin-dot i {
  background-color: ${(props) => props.theme.primarySolid} !important;
}

.ant-btn-primary:not(.ant-btn-dangerous) {
  color: ${(props) => props.theme.textColor} !important;
  border-color: ${(props) => props.theme.golden} !important;
  background: ${(props) => props.theme.golden};
  border-radius: 12px;
  height: 56px;

  :hover {
    color: ${(props) => props.theme.textColor} !important;
    border-color: ${(props) => props.theme.golden} !important;
    background: ${(props) => props.theme.golden};
  }
}

.ant-btn-default {
  color: ${(props) => props.theme.whtie} !important;
  border-color: ${(props) => props.theme.blackGradient} !important;
  background: ${(props) => props.theme.blackGradient};
  border-radius: 12px;
  height: 56px;

  :hover {
    color: ${(props) => props.theme.whtie} !important;
    border-color: ${(props) => props.theme.blackGradient} !important;
    background: ${(props) => props.theme.blackGradient};
  }
}

.ant-table-wrapper {
  
  tr:nth-child(2n) {
    td {
      background-color: #E1CCE0;
    }

    :hover {
      td {
        background-color: #E1CCE0 !important;
      }
    }
  }

  tr {
      >td {
        background-color: ${(props) => props.theme.background};

        font-size: 14px;
        font-weight: normal;
        color: #000000;

        :first-child, :last-child {
          padding: 8px 24px !important;
        }
    }

    :hover {
      >td {
        background-color: ${(props) => props.theme.background} !important;
      }
    }
  }

  tr>th {
    background-color: #71207C !important;
    font-size: 14px !important;
    font-weight: normal !important;
    color: #FFFFFF !important;

    ::before {
      display: none;
    }

    :first-child {
      border-start-start-radius: 5px !important;
      border-end-start-radius: 5px !important;
      padding: 8px 24px !important;
    }

    :last-child {
      border-start-end-radius: 5px !important;
      border-end-end-radius: 5px !important;
      padding: 8px 24px !important;
    }
  }
}

.ant-radio-wrapper .ant-radio-checked {
    
  ::after {
    border: 1px solid ${(props) => props.theme.primarySolid};
  }

  .ant-radio-inner {
    border-color: ${(props) => props.theme.primarySolid};
    background-color: ${(props) => props.theme.primarySolid};
  }
}

.ant-picker-calendar {
    .ant-radio-group {
        display: none !important;
    }
}

.ant-notification-notice {
  padding: 12px !important;
}

.ant-notification-notice-close {
  top: 12px !important;
}

.ant-notification-notice-description {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* Hide scrollbar for Chrome, Safari and Opera */
::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
-ms-overflow-style: none;  /* IE and Edge */
scrollbar-width: none;  /* Firefox */

.otp-length-8 {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 5px;

  @media screen and (max-width: 290px) {
    flex-wrap: wrap;
  }
}

.otp-length-6 {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 12px;

  @media screen and (max-width: 290px) {
    flex-wrap: wrap;
  }
}

.ant-modal .ant-modal-footer {
  .ant-btn {
    min-width: 90.5px;
  }
  .ant-btn-default {
    color: #fff;

    :hover {
      color: #fff !important;
    }
  }
}

.ant-modal .ant-modal-content {
  @media screen and (max-width: 325px) {
    padding: 20px 14px !important;
  }
}

.custom-calendar-modal {

  .ant-modal-footer {
      text-align: center;
  }

  @media screen and (max-width: 325px) {
    .ant-modal-content {
      padding: 20px 0 !important;
    }
  }
  
}

.ant-input:focus::placeholder {
    color: transparent !important;
  }

.grecaptcha-badge { visibility: hidden; }

`;

// export const Logo = styled.img.attrs({
//   alt: "logo-img",
//   src: LOGO,
// })``;

export default GlobalStyles;
